import { render, staticRenderFns } from "./CrearEditarTerapia.vue?vue&type=template&id=6945433c"
import script from "./CrearEditarTerapia.vue?vue&type=script&lang=js"
export * from "./CrearEditarTerapia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports